var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeasePin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0686 11C22.0686 14.9826 16.6887 21.0219 13.6883 24.0804C12.5991 25.1907 10.8483 25.1907 9.75919 24.0804C6.75881 21.0219 1.37891 14.9826 1.37891 11C1.37891 8.34784 2.4688 5.8043 4.40884 3.92893C6.34887 2.05357 8.98011 1 11.7237 1C14.4674 1 17.0986 2.05357 19.0386 3.92893C20.9787 5.8043 22.0686 8.34784 22.0686 11Z",
    fill: "#2B67F6",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7236 14C12.5467 14 13.336 13.6839 13.918 13.1213C14.5 12.5587 14.827 11.7956 14.827 11C14.827 10.2044 14.5 9.44129 13.918 8.87868C13.336 8.31607 12.5467 8 11.7236 8C10.9005 8 10.1111 8.31607 9.5291 8.87868C8.94709 9.44129 8.62012 10.2044 8.62012 11C8.62012 11.7956 8.94709 12.5587 9.5291 13.1213C10.1111 13.6839 10.9005 14 11.7236 14Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeasePin);
export default __webpack_public_path__ + "static/media/leasePin.8325143f4277ae0e232d8ca7cf311e55.svg";
export { ForwardRef as ReactComponent };